import { refa_logo_extended } from '@assets/icons';
import { GuideModal, TextInput } from '@components';
import { LoginErrorTextEnum } from '@constant';
import { useLogin } from '@hooks';
import { Button } from '@mui/material';
import { colorSet } from '@theme';
import { useForm } from 'react-hook-form';

const LoginPage = () => {
  const { handleLoginButtonClick, isErrorModalVisible, setIsErrorModalVisible, getErrorModalContent } = useLogin();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  return (
    <div
      style={{
        height: '100vh',
        backgroundColor: colorSet.gray100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src={refa_logo_extended} style={{ width: '178.84px', height: '82px', marginBottom: 40 }} />
        <form onSubmit={handleSubmit(handleLoginButtonClick)} style={{ width: 416 }}>
          <div style={{ display: 'grid', gap: 24, marginBottom: 40 }}>
            <TextInput
              label="ID"
              placeholder="ID"
              boxstyle={{ width: '100%' }}
              {...register('email', { required: 'ID를 입력하세요.' })}
              error={!!errors.email}
            />
            <TextInput
              type="password"
              label="PASSWORD"
              placeholder="PASSWORD"
              boxstyle={{ width: '100%' }}
              {...register('password', { required: '비밀번호를 입력하세요.' })}
              error={!!errors.password}
            />
          </div>
          <Button type="submit" variant="contained" color="primary" sx={{ width: '100%' }}>
            LOGIN
          </Button>
        </form>
      </div>

      <GuideModal
        isVisible={isErrorModalVisible}
        onClose={() => {
          setIsErrorModalVisible(false);
        }}
        title={LoginErrorTextEnum.TITLE}
        content={getErrorModalContent()}
        buttonText="닫기"
        buttonVariant="outlined"
      />
    </div>
  );
};

export default LoginPage;
